import {CALL_API} from 'redux-api-middleware';
import {
  API_RISK_ASSESSMENT_POST_REQUEST,
  API_RISK_ASSESSMENT_POST_SUCCESS,
  API_RISK_ASSESSMENT_POST_FAILURE,
  API_ORG_GET_BY_DUNS_REQUEST,
  API_ORG_GET_BY_DUNS_SUCCESS,
  API_ORG_GET_BY_DUNS_FAILURE,
  API_ORG_GET_BY_UEIEFT_REQUEST,
  API_ORG_GET_BY_UEIEFT_SUCCESS,
  API_ORG_GET_BY_UEIEFT_FAILURE,
  API_ORG_GET_BY_ID_REQUEST,
  API_ORG_GET_BY_ID_SUCCESS,
  API_ORG_GET_BY_ID_FAILURE,
  API_ORG_GET_BY_USER_REQUEST,
  API_ORG_GET_BY_USER_SUCCESS,
  API_ORG_GET_BY_USER_FAILURE,
  API_ORG_SEARCH_ON_DBA_LEGALNAME_REQUEST,
  API_ORG_SEARCH_ON_DBA_LEGALNAME_SUCCESS,
  API_ORG_SEARCH_ON_DBA_LEGALNAME_FAILURE,
  API_CREATE_UPDATE_ORG_REQUEST,
  API_CREATE_UPDATE_ORG_SUCCESS,
  API_CREATE_UPDATE_ORG_FAILURE,
  API_CREATE_SUB_ORG_REQUEST,
  API_CREATE_SUB_ORG_SUCCESS,
  API_CREATE_SUB_ORG_FAILURE,
  API_LINK_APP_TO_VENDOR_REQUEST,
  API_LINK_APP_TO_VENDOR_SUCCESS,
  API_LINK_APP_TO_VENDOR_FAILURE,
  API_ORG_GET_BY_DUNS_FROM_SAMGOV_REQUEST,
  API_ORG_GET_BY_DUNS_FROM_SAMGOV_SUCCESS,
  API_ORG_GET_BY_DUNS_FROM_SAMGOV_FAILURE,
  API_ORG_GET_ALL_SUBORGS_REQUEST,
  API_ORG_GET_ALL_SUBORGS_SUCCESS,
  API_ORG_GET_ALL_SUBORGS_FAILURE,
  API_ORGS_LIST_GET_BY_ID_REQUEST,
  API_ORGS_LIST_GET_BY_ID_SUCCESS,
  API_ORGS_LIST_GET_BY_ID_FAILURE,
  API_ADD_SUB_ORG_REQUEST,
  API_ADD_SUB_ORG_SUCCESS,
  API_ADD_SUB_ORG_FAILURE,
} from 'common/types';
import _ from 'lodash';
import {
  ENDPOINT_ORGANIZATION,
  ENDPOINT_USER,
  ENDPOINT_ORGANIZATION_V3,
} from 'common/endpoints';
import {checkIfDefinedNonNullAndNotEmptyString} from 'common/utils';
import goStore from 'go/store';
import {getInfo} from 'common/storeUtils';
import {commonJwtHeader} from 'common/utils';

export default {
  // gets an org already imported to fema go
  getOrganizationByDUNS: (token, duns) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_ORGANIZATION}search?duns=${duns}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_ORG_GET_BY_DUNS_REQUEST,
          API_ORG_GET_BY_DUNS_SUCCESS,
          API_ORG_GET_BY_DUNS_FAILURE,
        ],
      },
    };
  },

  getOrganizationByUEIEFT: (token, ueiEft) => {
    const ueiTrimmed = ueiEft.replace('-', '');
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_ORGANIZATION}search?uei=${ueiTrimmed}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_ORG_GET_BY_UEIEFT_REQUEST,
          API_ORG_GET_BY_UEIEFT_SUCCESS,
          API_ORG_GET_BY_UEIEFT_FAILURE,
        ],
      },
    };
  },
  // gets an org already imported to fema go
  getOrganizationById: (token, orgId) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_ORGANIZATION}${orgId}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_ORG_GET_BY_ID_REQUEST,
          API_ORG_GET_BY_ID_SUCCESS,
          API_ORG_GET_BY_ID_FAILURE,
        ],
      },
    };
  },
  // gets an org already imported to fema go
  getOrganizationByDbaOrLegalName: (token, keywords, pageNum) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_ORGANIZATION}${
         'fuzzySearch'
        }?query=${keywords}&pageNum=${pageNum}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_ORG_SEARCH_ON_DBA_LEGALNAME_REQUEST,
          API_ORG_SEARCH_ON_DBA_LEGALNAME_SUCCESS,
          API_ORG_SEARCH_ON_DBA_LEGALNAME_FAILURE,
        ],
      },
    };
  },
  // gets an org based on duns, imports from samgov if not in system (up-to-now samgov data)
  createUpdateOrg: (token, duns) => {
    const endPointToUse = ENDPOINT_ORGANIZATION + (`${duns}`);

    return {
      [CALL_API]: {
        endpoint: endPointToUse,
        headers: commonJwtHeader(),
        method: 'POST',
        types: [
          API_CREATE_UPDATE_ORG_REQUEST,
          API_CREATE_UPDATE_ORG_SUCCESS,
          API_CREATE_UPDATE_ORG_FAILURE,
        ],
      },
    };
  },
  createSubOrg: (token, payload, orgId) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_ORGANIZATION}${orgId}/suborganization`,
        headers: commonJwtHeader(),
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          API_CREATE_SUB_ORG_REQUEST,
          API_CREATE_SUB_ORG_SUCCESS,
          API_CREATE_SUB_ORG_FAILURE,
        ],
      },
    };
  },

  // TODO, see if this can be merged with createSubOrg
  addAndEditSubOrg: (token, orgId, subOrgId, payload) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_ORGANIZATION}${orgId}/suborganization`,
        headers: commonJwtHeader(),
        body: JSON.stringify(payload),
        method: 'POST',
        types: [
          API_ADD_SUB_ORG_REQUEST,
          API_ADD_SUB_ORG_SUCCESS,
          API_ADD_SUB_ORG_FAILURE,
        ],
      },
    };
  },
  // TODO, remove this, it's only used in code behind a toggle already in PROD, should have been in a user file, but just delete it if you're going to refactor
  getOrganizationsByCurrentUser: (token) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_USER}entity`,
        method: 'GET',
        headers: commonJwtHeader(),
        types: [
          API_ORG_GET_BY_USER_REQUEST,
          API_ORG_GET_BY_USER_SUCCESS,
          API_ORG_GET_BY_USER_FAILURE,
        ],
      },
    };
  },
  // set off process to link application with this grant number and associated objects to this org
  linkApplicationToVendor: (token, grantNumber, orgId, vendorId) => {
    const endPointToUse =
    ENDPOINT_ORGANIZATION +
      (`sync?organizationId=${orgId}&grantNumber=${grantNumber}&vendorId=${vendorId}`);

    return {
      [CALL_API]: {
        endpoint: endPointToUse,
        headers: commonJwtHeader(),
        method: 'POST',
        types: [
          API_LINK_APP_TO_VENDOR_REQUEST,
          API_LINK_APP_TO_VENDOR_SUCCESS,
          API_LINK_APP_TO_VENDOR_FAILURE,
        ],
      },
    };
  },
  // get an org based on duns from sam.gov
  getOrganizationByDUNSFromSAMGOV: (token, duns) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_ORGANIZATION}samgov/${duns}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_ORG_GET_BY_DUNS_FROM_SAMGOV_REQUEST,
          API_ORG_GET_BY_DUNS_FROM_SAMGOV_SUCCESS,
          API_ORG_GET_BY_DUNS_FROM_SAMGOV_FAILURE,
        ],
      },
    };
  },

  // gets all suborgs already imported to fema go
  getAllSuborganizations: (token, orgId) => {
    const methodToUse = 'POST';

    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_ORGANIZATION}suborganizations/search/${orgId}`,
        headers: commonJwtHeader(),
        method: methodToUse,
        types: [
          API_ORG_GET_ALL_SUBORGS_REQUEST,
          API_ORG_GET_ALL_SUBORGS_SUCCESS,
          API_ORG_GET_ALL_SUBORGS_FAILURE,
        ],
      },
    };
  },
  // gets an org already imported to fema go
  getOrganizationsListById: (token, orgIds) => {
    const orgIdsAsArray = _.isArray(orgIds) ? orgIds : [orgIds];

      return {
        [CALL_API]: {
          endpoint: `${ENDPOINT_ORGANIZATION}organizations`,
          headers: commonJwtHeader(),
          method: 'POST',
          body: JSON.stringify({
            ids: _.map(
              _.filter(orgIdsAsArray, (orgId) =>
                checkIfDefinedNonNullAndNotEmptyString(orgId)
              ),
              _.toNumber
            ),
          }), // api accepts array of integers
          types: [
            API_ORGS_LIST_GET_BY_ID_REQUEST,
            API_ORGS_LIST_GET_BY_ID_SUCCESS,
            API_ORGS_LIST_GET_BY_ID_FAILURE,
          ],
        },
      };
  },
};
